import { isEditEntryMode, SaveType } from '../../../@types/types'
import { ValidationSchema } from '../../../@types/validation-types'
import { DispatchType } from '../../../@types/redux-types'
import { InitState } from '../../reducers/root/initialState'
import { doAutoSave } from './doAutoSave'

export const doAutoSaveDecider =
  (validationSchema: ValidationSchema) => (dispatch: DispatchType, getState: () => InitState) => {
    const entryMode = getState().insertionFeature.insertionIdentification.metaInformation?.entryMode
    const failedToSave = getState().insertionFeature.save === SaveType.FAILED_TO_SAVE
    const isEditMode = isEditEntryMode(entryMode)

    if (failedToSave || isEditMode) {
      return
    }

    doAutoSave(validationSchema)(dispatch, getState)
  }
